(() => {
  if (customElements.get('shop-look')) {
    return;
  }

  class showLook extends HTMLElement {
    constructor() {
      super();

      this.slider = null;
      this.controls = null;
      this.controlsWrapper = this.querySelector('[data-controls-wrapper]');
      this.cardsSize = this.dataset.cardsSize || 'default';
      this.shouldDestroyOnDesktop = this.hasAttribute('data-destroy');
      this.breakpoints = {
        desktop: 990,
      };
      this.dots = this.querySelectorAll('[data-showcase-points="button"]');
    }

    connectedCallback() {
      this.initSlider();
      this.toggleSliderHandler();
      window.addEventListener(
        'resize',
        debounce(this.toggleSliderHandler.bind(this), 500)
      );
      this.dots.forEach((dot) =>
        dot.addEventListener('click', this.handleDotClick.bind(this))
      );
      this.slider.on('slideChange', this.handleSlideChange.bind(this));
    }

    handleSlideChange() {
      const index = this.slider.activeIndex;
      const relatedDot = this.querySelector(`[data-showcase-points="button"][data-id="${index}"]:not(.is-active)`);

      if (!relatedDot) {
        return;
      }

      this.dots.forEach((dot) => dot.classList.remove('is-active'));
      relatedDot.classList.add('is-active');
    }

    handleDotClick(e) {
      const index = Number(e.target.dataset.id);

      if (Number.isNaN(index)) {
        return;
      }

      this.dots.forEach((dot) => dot.classList.remove('is-active'));
      e.target.classList.add('is-active');
      this.slider.slideTo(index);
    }

    initSlider() {
      const sliderList = this.querySelector('.swiper');

      if (!sliderList) return;

      const mainSettings = {
        spaceBetween: 24,
        watchOverflow: true,
        speed: 300,
        navigation: {
          nextEl: '.shop-look__control-next',
          prevEl: '.shop-look__control-prev',
        },
        pagination: false,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        slidesPerView: 1.25,
        breakpoints: {
          990: {
            spaceBetween: 48,
            slidesPerView: 1,
          }
        }
      };

      this.controls = this.querySelectorAll('[data-control]');
      this.controls.forEach((control) => {
        control.addEventListener('click', this.onControlClick.bind(this));
      });

      this.slider = new Swiper(
        this.querySelector('.swiper'),
        mainSettings
      );
    }

    toggleSliderHandler() {
      if (!this.shouldDestroyOnDesktop) return;
      try {
        this.toggleSlider(window.innerWidth >= this.breakpoints.desktop);
      } catch (e) {}
    }

    toggleSlider(destroy) {
      destroy ? this.slider.destroy() : this.slider.init();
      this.controlsWrapper.classList.toggle('hidden', destroy);
    }

    onControlClick(event) {
      event.preventDefault();

      if (!this.slider) {
        return;
      }

      const action = event.target.hasAttribute('data-prev') ? 'prev' : 'next';

      this.slider[action]();
    }
  }

  customElements.define('shop-look', showLook);
})();
